import { useState, useEffect } from "react";
import Backend from "../utils/api.js";

function useVersion() {
  const [versionInfo, setVersionInfo] = useState({ version: null, environment: null });

  useEffect(() => {
    Backend.getVersion().then(setVersionInfo);
  }, []);

  return versionInfo;
}

export default useVersion;
